import React, { useState } from 'react';
import Modal, { buttonClass, primaryButtonClass } from 'features/dashboards/components/Modal';
import { setEditors } from 'features/dashboards/api/dashboardsApi';
import { errorText } from 'features/dashboards/format';

/** The owner picks which team members may edit. Everyone else views. */
export default function EditorsDialog({ team, dashboard, onChanged, onClose }) {
  const [picked, setPicked] = useState(() => new Set((dashboard.editors || []).map((e) => e.id)));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const members = (dashboard.members || []).filter((m) => m.id !== dashboard.owner?.id);

  const toggle = (id) => setPicked((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const save = async () => {
    setSaving(true); setError(null);
    try { await setEditors(team, dashboard.id, [...picked]); onChanged?.(); onClose(); } catch (e) { setError(errorText(e)); } finally { setSaving(false); }
  };

  return (
    <Modal title="Editors" onClose={onClose}
      footer={<><button type="button" className={buttonClass} onClick={onClose}>Cancel</button><button type="button" className={primaryButtonClass} disabled={saving} onClick={save}>Save</button></>}>
      <div className="px-4 py-3">
        {error ? <div className="mb-2 rounded-lg border border-[color:var(--feedback-error)] bg-[color:var(--feedback-error-bg)] px-3 py-2 text-[12px] text-[color:var(--feedback-error)]">{error}</div> : null}
        {members.length === 0 ? <p className="py-4 text-center text-[12px] text-[color:var(--text-muted)]">No other members on this team</p> : (
          <ul className="divide-y divide-[color:var(--border-subtle)]">
            {members.map((m) => (
              <li key={m.id}>
                <label className="flex cursor-pointer items-center gap-2 py-2 text-[12px]">
                  <input type="checkbox" className="h-3.5 w-3.5 accent-[color:var(--trodo-primary)]" checked={picked.has(m.id)} onChange={() => toggle(m.id)} />
                  <span className="text-[color:var(--text-primary)]">{m.name || m.email}</span>
                  {m.name && m.email ? <span className="text-[color:var(--text-muted)]">{m.email}</span> : null}
                </label>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Modal>
  );
}
